<template>
  <div>
    <TopBar currentTitle="Tips">
      <b-button type="is-primary" size="is-small" icon-left="plus" @click="createNewTip">Add Tip</b-button>
    </TopBar>
    <div class="page-content">
    <h1 class="page-title">Tips</h1>
    <p class="page-subtitle mb-4">{{ tips.length }} total</p>

    <!-- Table Card -->
    <div class="feeds-card">
      <div class="feeds-card-body compact">
        <b-table
          :data="tips"
          :hoverable="true"
          @click="openTip">

          <b-table-column width=80 label="Sticker" sortable v-slot="props">
            <figure class="m-0 p-0 image">
              <img v-if="rowImageSrc(props.row) == null" class="thumbnail" src="@/assets/listing-placeholder.png">
              <img v-else class="thumbnail" :src="rowImageSrc(props.row)">
            </figure>
          </b-table-column>

          <b-table-column field="title" label="Title" sortable v-slot="props">
            <p class="pt-1 px-3 has-text-weight-bold" :style="rowStyle(props.row)">
              {{ props.row.title }}
            </p>
            <p class="pb-1 px-3 m-0" :style="rowStyle(props.row)" v-html="props.row.body" />
          </b-table-column>

          <b-table-column field="status" width=100 label="Status" sortable centered v-slot="props">
            <FeedsStatusBadge :status="props.row.status" />
          </b-table-column>

          <b-table-column field="created_at" width=100 label="Created" sortable centered v-slot="props">
            <span class="date-tag">{{ new Date(props.row.created_at).toLocaleDateString() }}</span>
          </b-table-column>

          <b-table-column field="id" width=60 label="ID" v-slot="props">
            <p class="is-size-7 has-text-grey">{{ props.row.id }}</p>
          </b-table-column>

          <b-table-column field="options" custom-key="actions" width=20 v-slot="props">
            <b-dropdown aria-role="list" position="is-bottom-left" @click.native.stop>
              <template #trigger>
                <b-button icon-right="dots-vertical" />
              </template>
              <b-dropdown-item aria-role="listitem" @click="duplicateTip(props.row)">
                <b-icon size="is-small" icon="content-copy"></b-icon>
                Duplicate
              </b-dropdown-item>
              <b-dropdown-item class="has-text-danger" aria-role="listitem" @click="deleteTip(props.row)">
                <b-icon size="is-small" icon="delete"></b-icon>
                Delete
              </b-dropdown-item>
            </b-dropdown>
          </b-table-column>
        </b-table>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import db from "@/firebase/db"
import FeedsStatusBadge from '@/components/common/FeedsStatusBadge.vue'
import TopBar from '@/components/layout/TopBar.vue'

const SCROLL_STATE_KEY = 'feeds_list_state_TipsEncouragementListView'

export default {
  name: 'TipsEncouragementListView',
  components: {
    FeedsStatusBadge,
    TopBar
  },
  data() {
    return {
      tips: [],
      scrollRestored: false
    }
  },
  watch: {
    tips() {
      if (!this.scrollRestored) {
        this.scrollRestored = true
        this.$nextTick(() => {
          const savedState = sessionStorage.getItem(SCROLL_STATE_KEY)
          if (savedState) {
            const state = JSON.parse(savedState)
            if (state.scrollY > 0) {
              setTimeout(() => window.scrollTo(state.scrollX, state.scrollY), 50)
            }
          }
        })
      }
    }
  },
  firestore: {
    tips: db.collection('tips_encouragements').orderBy("created_at", "desc")
  },
  methods: {
    createNewTip() {
      db.collection("tips_encouragements").add({
        created_at: Date.now(),
        title: "You can do it!",
        status: "draft",
        date: null,
      })
      .then((docRef) => {
        this.$router.push({ name: 'TipEncouragementView', params: { id: docRef.id } })
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
    },
    openTip(tip) {
      this.$router.push({ name: 'TipEncouragementView', params: { id: tip.id } })
    },
    deleteTip(tip) {
      this.$buefy.dialog.confirm({
        title: 'Deleting tip',
        message: `Are you sure you want to delete tip: <b><i>"${tip.title}"</i></b>? <br /><br />This action cannot be undone.`,
        confirmText: 'Delete Tip',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          db.collection("tips_encouragements").doc(tip.id)
          .delete()
          .then(() => {
            this.$buefy.toast.open({type: 'is-success', message: `Tip successfully deleted!`})
          }).catch((error) => {
            this.$buefy.toast.open({type: 'is-danger', message: `Error deleting tip: ${error}`})
          });
        }
      })
    },
    duplicateTip(tip) {
      db.collection("tips_encouragements").doc(tip.id)
        .get()
        .then((doc) => {
          if (doc.exists && doc.data()) {
            let newData = doc.data();
            newData['created_at'] = Date.now();
            newData['status'] = "draft";
            return db.collection("tips_encouragements").add(newData)
              .then((docRef) => {
                this.$buefy.toast.open({type: 'is-success', message: `Tip successfully duplicated! ${docRef.id}`})
              });
          }
        })
        .catch((error) => {
          this.$buefy.toast.open({type: 'is-danger', message: `Error duplicating tip ${tip.id}: ${error}`})
        });
    },
    rowStyle(tip) {
      if (tip.background_color == null || tip.foreground_color == null) return null;
      return {
        margin: 0,
        backgroundColor: tip.foreground_color.colour,
        color: tip.foreground_color.invertTheme == "dark" ? "#333333" : "#F2F9EE"
      }
    },
    rowImageSrc(tip) {
      if (tip.sticker == null) return null;
      return tip.sticker.src;
    }
  }
}
</script>

<style scoped>
.thumbnail {
  height: 100% !important;
  object-fit: cover;
  border-radius: var(--radius-sm);
}

.date-tag {
  font-size: 12px;
  color: var(--text-secondary);
}
</style>
